import React from "react";
import { FaUser, FaPhoneAlt, FaUserNurse } from "react-icons/fa";
import { calculateAge } from "../utils/ageCalculator";

const SeniorProfileSummary = ({ profile }) => {
  // Default values for display if profile is not available
  const displayName = profile?.profileName || "N/A";
  const age =
    profile?.dob || profile?.dateOfBirth
      ? calculateAge(profile.dob || profile.dateOfBirth)
      : "N/A";
  const primarySupportPerson = profile?.primaryCaregiver || "Not Assigned";
  const emergencyContact =
    profile?.emergencyContactPhone ||
    profile?.emergencyContactNumber ||
    "Not Available";

  return (
    <div className="bg-white shadow-md rounded-lg p-3">
      <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
        {/* Profile Name */}
        <div className="flex items-center">
          <div className="mr-3 flex h-9 w-9 flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-100">
            {profile?.profilePictureURL ? (
              <img
                src={profile.profilePictureURL}
                alt={displayName}
                className="h-full w-full object-cover"
              />
            ) : (
              <FaUser className="text-xl text-slate-600" />
            )}
          </div>
          <h3 className="text-xl font-bold text-slate-800">{displayName}</h3>
        </div>

        {/* Primary support person */}
        <div className="hidden sm:flex items-center">
          <FaUserNurse className="text-slate-400 mr-2 text-lg" />
          <div>
            <p className="text-xs text-gray-500">Primary Support</p>
            <p className="font-semibold text-sm text-gray-700">
              {primarySupportPerson}
            </p>
          </div>
        </div>

        {/* Emergency Contact */}
        <div className="hidden sm:flex items-center">
          <FaPhoneAlt className="text-slate-400 mr-2 text-lg" />
          <div>
            <p className="text-xs text-gray-500">Emergency Contact</p>
            <p className="font-semibold text-sm text-gray-700">
              {emergencyContact}
            </p>
          </div>
        </div>

        {/* Age */}
        <span className="hidden sm:inline-block px-3 py-1 bg-slate-100 text-slate-700 text-xs font-semibold rounded-full">{`Age: ${age}`}</span>
      </div>
    </div>
  );
};

export default SeniorProfileSummary;
